import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getAccounts } from "../../../api/account";
import AccountsTable from "../../../components/Accounts/AccountsTable";
import { useErrorHandler } from "../../../hooks/Error/useErrorHandler";
import { setLoading } from "../../../store/UI";
import { Account } from "../../../types/model/account";

const AdminAccounts: React.FC = () => {
  const handleError = useErrorHandler();
  const [accounts, setAccounts] = useState<Account[]>([]);
  const dispatch = useDispatch();
  
  const fetchAccounts = async () => {
    try {
      dispatch(setLoading(true));
      const data = await getAccounts();
      setAccounts(data);
    } catch (error) {
      handleError(error);
    } finally {
      dispatch(setLoading(false));
    }
  };

  useEffect(() => {
    fetchAccounts();
  }, []);

  const handleRequestRefresh = () => {
    fetchAccounts();
  };

  return (
    <AccountsTable
      tableData={accounts}
      onRequestRefresh={handleRequestRefresh}
    />
  );
};

export default AdminAccounts;